/* global $ */

import React, { Component } from 'react';
import {calcDictionaryPercentages} from '../../lib/analytics.js';

export class Devices extends Component {

    constructor(props) {
        super(props);
        this.chart = null;
    }

    componentDidMount() {
        this.chart = $(this.refs.devices).highcharts({
            colors: ['#0073CF', '#5c2d91', '#9c5fb5'],
            chart: {
                type: 'pie',
                height: '320px'
            },
            title: {
                text: null
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            tooltip: {
                formatter: function() {
                    return this.point.name + "<br /><b>" + this.point.y + "%</b>";
                }
            },
            credits: {
                enabled: false
            },
            series: [{
                data: undefined
            }]
        });
        this.updateChart();
    }


    componentDidUpdate() {
        this.updateChart();
    }

    componentWillReceiveProps(props) {
        /*console.log(props.data);*/
        /*console.log(calcDictionaryPercentages(props.data, 'name', 'y'));*/
        this.chart.highcharts().series[0].setData(calcDictionaryPercentages(props.data, 'name', 'y'), true);
    }

    updateChart() {
        this.chart.highcharts().series[0].setData([{name:this.props.showMessage('message_1_05')},{name:this.props.showMessage('message_1_06')},{name:this.props.showMessage('message_1_07')}]);
    }

    render() {
        return (
            <div ref='devices'>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/analytics/Devices.jsx